import React from "react";

import { useRouter } from "next/router";

import { t } from "@lingui/macro";

import ManagePermissions from "components/permissions";

const UserGroupPermissions = () => {
  const router = useRouter();
  const { id } = router.query;

  const groupId = id?.toString() || "";
  return (
    <ManagePermissions
      canManage={true}
      permissionPath={`forms/${groupId}/group_permissions/`}
      title={t`User Group permissions`}
      recordsPath="user_groups/"
      iteratee="user_group"
      tabsTitle={{
        permissions: t`User groups with permissions`,
        allPermissions: t`All user groups`,
      }}
      permissionDetails={{
        detailsEndpoint: "group_permission_details",
        objectType: "forms",
        objectValue: groupId,
        permissionKey: "user_group",
      }}
      titleIndex="name_display"
      offSetTop={10}
    />
  );
};

export default UserGroupPermissions;
